import { render, staticRenderFns } from "./MessageApprovalView.vue?vue&type=template&id=27950d14"
import script from "./MessageApprovalView.ts?vue&type=script&lang=ts&external"
export * from "./MessageApprovalView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports